import { useLiteSiteStore } from "../store";

export function useUpcomingIntersectingDays() {
  return useLiteSiteStore(({ upcomingIntersectingDays }) => upcomingIntersectingDays);
}
